// Thirdparty
import React, { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";
// Styles
import "./../styles/Deposit.css";
// Assets
import bulbIcon from "../assets/bulb.icon.svg";
import copyIcon from "../assets/copy-icon.svg";
import helpIcon from "../assets/help-icon.svg";
import bitcoinIcon from "../assets/bitcoin-icon.svg";
import USDTIcon from "../assets/usdt-icon.svg";
import lightIcon from "../assets/light-icon.svg";
// Components
import Select from "../components/Select";
// Utils
import { copyTextToClipboard } from "../utils";
// Services
const Routes = require("./../services/routes.js");

async function fetchAddress(chain){
  try{
    const url = Routes.getAuthWalletURL() + "/deposit";
    const origin = window.location.origin;
    console.debug(`Sending message to ${url} with origin ${origin}`);
    
    const response = await fetch(
      url,
      {
        method: "POST",
        headers: {"content-type": "application/json"},
        credentials: "include",
        body: JSON.stringify(chain),
      }
    );
    const result = await response.json();

    // Failure
    if(!response.ok){
      console.error(`Failed to fetch address: ${response.statusText} Status:${response.status}`);
      
      // If the response was unauthorized
      if(response.status===401){
        localStorage.removeItem('verified'); // Remove verified
        window.location = `/`; // redirect the page to the home page.
      }
      //showErrorMessage(result.message);
      return;
    }
    // Redirect
    else if (result.redirect){
      window.location = result.url;
      localStorage.removeItem('verified');
      return;
    }
    else if(typeof result.verified !== 'undefined'){
      localStorage.verified = result.verified;
    }
    
    return result.address
  }
  catch(err){
    console.error("Failed fetch address: ", err);
  }
}

function Deposit() {
  // States
  const [address, setAdress] = useState("");
  const [showAddress, setShowAddress] = useState(false);
  const [copyStatus, setCopyStatus] = useState("");
  const [depositValue, setDepositValue] = useState("");
  const [networkValue, setNetworkValue] = useState("");

  const depositOptions = [
    { value: "BTC", label: "BTC", icon: bitcoinIcon },
    { value: "USDT", label: "USDT", icon: USDTIcon },
  ];

  const networkOptions = [
    { value: "BITCOIN", label: "Bitcoin", icon: bitcoinIcon },
    { value: "LIGHTNING", label: "Lightning", icon: lightIcon },
  ];

  const handleCopy = async () => {
    const success = await copyTextToClipboard(address);
    setCopyStatus(success ? "Copied!" : "Failed to copy");
  };

  useEffect(() => {
    // Only need to fetch account if logged in!
    if (localStorage.verified===undefined){
      window.location = `/`; // redirect the page to the home page.
    }
    
    setShowAddress(false);
  }, []);

  async function handleAcknowledgement() {
    const depositAddress = await fetchAddress({
      network: networkValue.value,
      coin: depositValue.value
    });

    if (depositAddress){
      setAdress(depositAddress)
      setShowAddress(true);
    }
  }

  return (
    <div className="depositContainer">
      <div className="depositWrapper">
        <div className="headingWrapper">
          <div className={`stepCount ${depositValue && "step-active-color"}`}>
            1
          </div>
          <h3>Choose coin to deposit</h3>
        </div>
        <div className="selectWrapper">
          <Select
            options={depositOptions}
            value={depositValue}
            handleChange={(value) => {
              setDepositValue(value);
              setNetworkValue("");
              setShowAddress(false);
              setCopyStatus("");
            }}
          />
        </div>
        <div className="headingWrapper">
          <div className={`stepCount ${networkValue && "step-active-color"}`}>
            2
          </div>
          <h3>Choose a Network</h3>
        </div>
        <div className="selectWrapper">
          <Select
            options={networkOptions}
            value={networkValue}
            handleChange={(value) => {
              setNetworkValue(value);
              setShowAddress(false);
              setCopyStatus("");
            }}
            isDisabled={!depositValue}
          />
        </div>
        <div className="headingWrapper">
          <div className={`stepCount ${showAddress && "step-active-color"}`}>3</div>
          <h3>Confirm deposit details</h3>
        </div>

        {showAddress ? (
          <div className="selectWrapper depositMsg">
            <div>
              <img src={bulbIcon} alt="bulb" height={40} />
              <p>
                Please confirm that you are depositing BTC to this address on
                the BTC network. Mismatched address information may result in
                the permanent loss of your assets.
              </p>
            </div>
            <div className="key-label">
              <p className="label">BTC Address</p>
              {copyStatus && <p>{copyStatus}</p>}
            </div>
            <div className="dopositCode">
              <p>{address}</p>
              <div className="copyIcon" onClick={handleCopy}>
                <img src={copyIcon} alt="copy" height={20} />
                <p>copy</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="selectWrapper confirmationMsg">
            <div>
              <img src={bulbIcon} alt="bulb" height={40} />
              <p>
                Please confirm that you are depositing BTC to this address on
                the BTC network. Mismatched address information may result in
                the permanent loss of your assets.
              </p>
            </div>
            <div className="acknowledge-btn-wrapper">
              <button
                type="button"
                className="acknowledge-btn"
                onClick={() => {
                  handleAcknowledgement();
                }}
                disabled={!depositValue || !networkValue}
              >
                Acknowledge
              </button>
            </div>
          </div>
        )}

        <div>
          <div className="deposit-info">
            <div className="flex-row">
              <p>Minimum Deposit Amount</p>
              <img data-tooltip-id="deposit-amount" src={helpIcon} alt="info" />
            </div>
            <Tooltip
              id="deposit-amount"
              place="top"
              content="Deposits below the minimum will be lost"
            />
            <p>0.000006 BTC</p>
          </div>
          <div className="deposit-arival-info">
            <div className="flex-row">
              <p>Deposit Arrival</p>
              <img
                data-tooltip-id="arrival-tooltip"
                src={helpIcon}
                alt="info"
              />
              <Tooltip
                id="arrival-tooltip"
                place="top"
                content="Funds will show up in your account after 1 block confirmation"
              />
            </div>
            <p>1 confirmation</p>
          </div>

          <div className="deposit-arival-info">
            <div className="flex-row">
              <p>Funds use</p>
              <img data-tooltip-id="fund-tooltip" src={helpIcon} alt="info" />
              <Tooltip
                id="fund-tooltip"
                place="top"
                content="Funds will be available for use of 2 block confirmations"
              />
            </div>
            <p>2 confirmations</p>
          </div>
        </div>
      </div>
      <div className="FAQ-container">
        <h2>FAQ</h2>

        <ul>
          <li>How to Make a Deposit</li>
          <li>Unsupported Deposit Recovery Procedure Rules</li>
          <li>How to Recover a Deposit with Wrong or Missing Tag/Memo</li>
          <li>Deposits yet to be credited</li>
          <li>Deposit/Withdrawl Status</li>
        </ul>
      </div>
    </div>
  );
}

export default Deposit;
